import { useEffect, useState } from "react";
import api from "./axios";

export const getPublicCatalog = async () => {
  const response = await api.get("/api/catalog");
  return response.data;
};

export const usePublicCatalog = () => {
  const [catalog, setCatalog] = useState({ services: [], products: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    getPublicCatalog()
      .then((data) => {
        if (!active) return;
        setCatalog({
          services: Array.isArray(data?.services) ? data.services : [],
          products: Array.isArray(data?.products) ? data.products : [],
        });
      })
      .catch((requestError) => {
        if (active) {
          setError(
            requestError?.response?.data?.message ||
              "The catalogue could not be loaded. Please try again later.",
          );
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { ...catalog, loading, error };
};

export const catalogueItemKey = (item) => `${item.company_id}:${item.id}`;
